import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {Fab, useTheme} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import {Delete, Message, Remove} from "@material-ui/icons";


const useStyles = makeStyles(theme => ({
    root: {
        maxWidth: 345,
        margin: '2rem 2rem',
    },
    content: {
        textAlign: 'center',
    },
    media: {
        height: 140,
        width: 140,
        margin: '1rem 2rem',
        borderRadius: '60%',
        border: '4px solid #ccc',
        '&.active': {
            border: '4px solid '+ theme.palette.primary.main,
        }
    },
}));

export default function KidCard(props: any) {
    const theme = useTheme();
    const classes = useStyles(theme);
    const active = props.active ? 'active' : null;
    return (
        <Card className={classes.root}>
            <CardActionArea>
                <CardMedia
                    className={[classes.media, active].join(' ')}
                    image={props.avatar}
                    title={props.kidName}
                />
                <CardContent className={classes.content}>
                    <Typography gutterBottom variant="h5" component="h2">
                        {props.kidName}
                    </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Fab size="small" color="primary"> <Message/> </Fab>
                <Fab size="small" color="primary"> <EditIcon/> </Fab>
                <Fab size="small" color="secondary"> <Delete/> </Fab>
            </CardActions>
        </Card>
    );
}
